<template>
  <div :style="{ height, width }" id="EchartsBh" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    leftData1: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
            list:[
              

            ]
      }
  },
  mounted(){
    console.log(this.leftData1)
    this.loadEchartsAnimate(this.leftData1)
  },
  methods:{
      chartsRelativeSize(percent, derection) {
          var windowW = this.$refs.docement.offsetWidth;
          var windowH = this.$refs.docement.offsetHeight
          var r = 0;
          if ('h' === derection) {
              r = percent * windowH / 100;
          } else {
              r = percent * windowW / 100;
          }
          return r;
      },
      loadEchartsAnimate(list){
          var that = this
          var echarts = require('echarts');
          var myCharts = echarts.init(document.getElementById('EchartsBh'));
          var option = {
              color:['#407FFF','#00FFBA'],
              tooltip : {
                  trigger: 'axis',
                  textStyle:{
                      color:'#000',
                      fontSize: 30
                  },
                  formatter: function (params) {
                      var arr = [];
                      params.forEach(function (item) {
                          var N=item.seriesName;
                          var V = '';
                          if(item.value>100000000){//亿
                              V += (item.value/100000000).toFixed(1) + '亿';
                          }else if( item.value>10000){//万
                              V += (item.value/10000).toFixed(1) + '万';
                          }else{
                              V += item.value;
                          }
                          var a = {name:N,value:V};
                          arr.push(a);
                      });
                      var num = '';
                      arr.forEach(function (item) {
                          num += item.name+":"+item.value+"<br/>";
                      });
                      return params[0].name +"<br>"+ num;
                  }
              },
              grid: {
                  left: '50px',
                  right: '30px',
                  bottom: '30px',
                  top:'110px',
                  containLabel: true
              },
              legend: {
                  orient: 'horizontal',
                  top:'3%',
                  right:'30px',
                  itemWidth:27,
                  itemHeight:15,
                  itemGap:50,
                  textStyle:{
                      color:'#fff',
                      fontSize: 26,
                       padding: [5, 0, 0, 10]
                  },
                  data:['当前指数','历史指数','预测指数'],
                  z:10001
                  
              },
              xAxis: [
                  {
                      type: 'category',
                      axisLine: {
                          lineStyle: {
                              type: 'solid',
                              color: '#093027',//左边线的颜色
                              width: '1'//坐标线的宽度
                          }
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#fff',//坐标值得具体的颜色,
                              fontSize: 26
                          },
                          interval:0
                      },
                      axisTick:false,
                      data:list.time
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#2E3950',//左边线的颜色
                            width: '1'//坐标线的宽度
                        }
                      },
                      axisLabel: {
                        textStyle: {
                            color: '#e6e6e6',//坐标值得具体的颜色,
                            fontSize:26
                        }
                      },
                      axisTick:false,
                      splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
                        show: true,
                        lineStyle: {
                            color: ['#2E3950'],
                            width: 1,
                            type: 'dashed',
                        }
                      },
                      splitArea: {//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
                        interval: 1, //显示间隔的规律
                        show: false,
                        areaStyle: {//分隔区域的样式
                            color: ['rgba(255,255,255,0.03)', 'rgba(255,255,255,0)']
                        }
                      }
                  }
              ],
              series : [
                  {
                    name:'当前指数',
                    type:'bar',
                    barGap:0.4,
                    barWidth:20,
                    data:list.list[0],
                    itemStyle: {
                        normal: {
                            //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            barBorderRadius:[2, 2, 2, 2],
                          borderColor:"#19857F",
                          borderWidth:2,
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#001F37' },
                                { offset: 1, color: '#26F4EA' }
                                ],
                            )}
                    },
                  },{
                    name:'历史指数',
                    type:'bar',
                    barGap:0.2,
                    barWidth:20,
                    data:list.list[1],
                    itemStyle: {
                        normal: {
                            //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            barBorderRadius:[2, 2, 2, 2],
                          borderColor:"#704A25",
                          borderWidth:2,
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#031D35' },
                                { offset: 1, color: '#EA7B18' }
                                ],
                            )}
                        
                    }
                  },
                //   {
                //     name: '预测指数',
                //     type: 'line',
                //     symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
                //     showAllSymbol: true,
                //     symbolSize: 0,
                //     smooth: true,
                //     lineStyle: {
                //         normal: {
                //             width: 2,
                //         },
                //         borderColor: 'rgba(0,0,0,.4)',
                //     },
                //     itemStyle: {
                //         borderColor: '#2DE8FA',
                //         borderWidth: 2,
                //         color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                //            {
                //            offset: 0,
                //            color: '#2BCFDE'
                //            },
                //            {
                //            offset: 1,
                //            color: '#1BF2F3'
                //            }
                //      ])
                //     },
                //     tooltip: {
                //         show: true,
                //     },
                //     data:[],
                // },
              ]
          };
          myCharts.setOption(option);

      }
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
